class ConfiguracaoCfopController extends AbstractController
  @$inject = [ '$injector', 'pathService', 'configuracaoCfopService', 'cstService' ]

  constructor: ($injector, @pathService, @configuracaoCfopService, @cstService)->
    super($injector)
    @loadingTracker = @promiseTracker()

    url = @pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/pis-cofins/configuracao-cfop/'
    @modalConfiguracaoCfop = @openPopup(url + 'modal.html', 'configuracaoCfopModalController as ctrl', 'md')

    @lists = {
      listOfCstCofins: []
      listOfCstPis: []
    }

    @loadDefault()
    @loadDefaults()

  loadDefault: ->
    @loadingTracker.addPromise @configuracaoCfopService.getList((data)=>
      @listOfConfiguracaoCfop = data
    )

  loadDefaults: ->
    @cstService.getListByType('pis', (cstPis) =>
      @lists.listOfCstPis = cstPis

      @cstService.getListByType('cofins', (cstConfins) =>
        @lists.listOfCstCofins = cstConfins
      )
    )

  adicionar: () ->
    @modalConfiguracaoCfop({
        configuracaoCfop: -> {}
        lists: => @lists
      }, (result) => @loadDefault()
    )

  editar: (configuracaoCfop) ->
      @modalConfiguracaoCfop({
          configuracaoCfop: => configuracaoCfop
          lists: => @lists
        },
        (result) => @loadDefault()
      )

  remover: (configuracaoCfop)->
    @Confirm.warning("Atenção",
      "Deseja realmente apagar a configuração para o CFOP <strong>#{configuracaoCfop.cfop} - #{configuracaoCfop.descricao}</strong>?",
      {
        "Sim": =>
          @configuracaoCfopService.delete(configuracaoCfop.id, (data)=>
            if(data.success)
              @Alert.success("Configuração para o CFOP <strong>#{configuracaoCfop.cfop} - #{configuracaoCfop.descricao}</strong> removida com sucesso.")
              @loadDefault()
          )
        "Não": null
      })

angular.module("eficienciaFiscalModule").controller("configuracaoCfopController", ConfiguracaoCfopController)

class ConfiguracaoCfopModalController extends AbstractController
  @$inject = [ '$injector', '$uibModalInstance', 'configuracaoCfopService', 'configuracaoCfop', 'lists' ]

  constructor: ($injector, @modalInstance, @configuracaoCfopService, @configuracaoCfop, lists)->
    super($injector)

    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()

    @listOfCstPis = lists.listOfCstPis
    @listOfCstCofins = lists.listOfCstCofins

  listOfCstPisEntrada: ->
    return $.grep(@listOfCstPis, (cst) =>
      return cst.tipo == 'E' || cst.tipo == 'ES'
    )

  listOfCstPisSaida: ->
    return $.grep(@listOfCstPis, (cst)=>
      return cst.tipo == 'S' || cst.tipo == 'ES'
    )

  listOfCstCofinsEntrada: ->
    return $.grep(@listOfCstCofins, (cst) =>
      return cst.tipo == 'E' || cst.tipo == 'ES'
    )

  listOfCstCofinsSaida: ->
    return $.grep(@listOfCstCofins, (cst)=>
      return cst.tipo == 'S' || cst.tipo == 'ES'
    )

  salvar: (form, data) ->
    if form.$valid
      @submitTracker.addPromise(
        @configuracaoCfopService.save(angular.copy(data), (result) =>
          @Alert.success("Configuração para o CFOP <strong>#{result.cfop} - #{result.descricao}</strong> #{if data.id then 'atualizada' else 'adicionada'} com sucesso.",
            'Sucesso')
          @modalInstance.close()
        )
      )

angular.module("eficienciaFiscalModule").controller("configuracaoCfopModalController", ConfiguracaoCfopModalController)